import { DefaultDots } from './DefaultDots';
import { WhatsAppDots } from './WhatsAppDots';

export const dotVariants = {
  whatsapp: WhatsAppDots,
  default: DefaultDots
};
